import ReactOnRails from 'react-on-rails';
import OnepostUI from "onepost-ui";
import _ from 'lodash';

window._ = _;

// CRITICAL: Set ReactOnRails globally so all bundles use the same instance
// This prevents splitChunks from creating multiple ReactOnRails instances
// with separate component stores, which causes "registeredComponents: []" errors
// See: https://github.com/shakacode/react_on_rails/issues/991
window.ReactOnRails = ReactOnRails;

import AddConfirmToCalendar from '../bundles/AddConfirmToCalendar/components/AddConfirmToCalendar';
import AddOutreachApp from '../bundles/AddOutreach/startup/AddOutreachApp';
import ActivityFeedApp from '../bundles/ActivityFeed/startup/ActivityFeedApp';
import ArtistRepresentationApp from '../bundles/ArtistRepresentation/startup/ArtistRepresentationApp';
import AgentsTableApp from '../bundles/AgentsTable/startup/AgentsTableApp';
import AppMenuApp from '../bundles/AppMenu/startup/AppMenuApp';
import MobileMenuApp from '../bundles/MobileMenu/startup/MobileMenuApp';
import BulkRefundApp from '../bundles/BulkRefund/startup/BulkRefundApp';
import CalendarViewApp from '../bundles/CalendarView/startup/CalendarViewApp';
import CalendarViewV2App from '../bundles/CalendarViewV2/startup/CalendarViewV2App';
import CapacityBarChart from '../bundles/CapacityBarChart/components/CapacityBarChart';
import CheckoutAccordionApp from '../bundles/CheckoutAccordion/startup/CheckoutAccordionApp';
import VenueConductorApp from '../bundles/VenueConductor/startup/VenueConductorApp';
import VenueConductorModalApp from '../bundles/VenueConductor/startup/VenueConductorModalApp';
import ConfirmAttendeesApp from '../bundles/ConfirmAttendees/startup/ConfirmAttendeesApp';
import ConfirmationMemoApp from '../bundles/ConfirmationMemo/startup/ConfirmationMemoApp';
import ConfirmDashboardApp from '../bundles/ConfirmDashboard/startup/ConfirmDashboardApp';
import ConfirmShowApp from '../bundles/ConfirmShow/startup/ConfirmShowApp';
import ConfirmTicketingApp from '../bundles/ConfirmTicketing/startup/ConfirmTicketingApp';
import DataTable from '../bundles/DataTable/components/DataTable';
import DataTableWithSidebarViewApp from '../bundles/DataTableWithSidebarView/startup/DataTableWithSidebarViewApp';
import EditTourApp from '../bundles/EditTour/startup/EditTourApp';
import EditArtistSpotifyApp from '../bundles/EditArtistSpotify/startup/EditArtistSpotifyApp';
import EditArtistSocialApp from '../bundles/EditArtistSocial/startup/EditArtistSocialApp';
import AgentDetailsApp from '../bundles/AgentDetails/startup/AgentDetailsApp';
import AgentRosterApp from '../bundles/AgentRoster/startup/AgentRosterApp';
import ArtistContactsApp from '../bundles/ArtistContacts/startup/ArtistContactsApp';
import EmailNotificationSettingsApp from '../bundles/EmailNotificationSettings/startup/EmailNotificationSettingsApp';
import EventPageApp from '../bundles/EventPage/startup/EventPageApp';
import EventQrCodeApp from '../bundles/EventQrCode/components/EventQrCodeApp';
import TrackableLinkQrCodeApp from '../bundles/TrackableLinkQrCode/components/TrackableLinkQrCodeApp';
import EventsAssetCenterApp from '../bundles/EventsAssetCenter/startup/EventsAssetCenterApp';
import FanDashboardApp from '../bundles/FanDashboard/startup/FanDashboardApp';
import FanUpcomingEventsApp from '../bundles/FanUpcomingEvents/startup/FanUpcomingEventsApp';
import FollowUpManagerApp from '../bundles/FollowUpManager/startup/FollowUpManagerApp';
import GivingCampaignDashboardApp from '../bundles/GivingCampaignDashboard/startup/GivingCampaignDashboardApp';
import GivingCampaignDetailApp from '../bundles/GivingCampaignDetail/startup/GivingCampaignDetailApp';
import GivingCampaignFormApp from '../bundles/GivingCampaignForm/startup/GivingCampaignFormApp';
import GivingCampaignTypeSelectorApp from '../bundles/GivingCampaignTypeSelector/startup/GivingCampaignTypeSelectorApp';
import PublicGivingCampaignApp from '../bundles/PublicGivingCampaign/startup/PublicGivingCampaignApp';
import GlobalAssetCenterApp from '../bundles/GlobalAssetCenter/startup/GlobalAssetCenterApp';
import InboundSubmissionsApp from '../bundles/InboundSubmissions/startup/InboundSubmissionsApp';
import LinkOfferModalApp from '../bundles/LinkOfferModal/startup/LinkOfferModalApp';
import MapWithMarker from '../bundles/MapWithMarker/components/MapWithMarker';
import MapWithMarkerClusters from '../bundles/MapWithMarkerClusters/components/MapWithMarkerClusters';
import MarketingInsightsApp from '../bundles/MarketingInsights/startup/MarketingInsightsApp';
import MetaAdsDetailsApp from '../bundles/MetaAdsDetails/startup/MetaAdsDetailsApp';
import ActionContainer from '../bundles/Marketing/Campaigns/Actions/ActionContainer';
import CampaignsContainer from '../bundles/Marketing/Campaigns/CampaignsContainer';
import CampaignContainer from '../bundles/Marketing/Campaigns/CampaignContainer';
import CustomCampaignShowContainer from '../bundles/Marketing/CustomCampaigns/CustomCampaignShowContainer';
import SegmentsContainer from '../bundles/Marketing/Segments/SegmentsContainer';
import SegmentContainer from '../bundles/Marketing/Segments/SegmentContainer';
import SegmentNewContainer from '../bundles/Marketing/Segments/SegmentNewContainer';
import SegmentEditContainer from '../bundles/Marketing/Segments/SegmentEditContainer';
import SetlistPageHeaderApp from '../bundles/SetlistPageHeader/startup/SetlistPageHeaderApp';
import BroadcastIndexContainer from '../bundles/Marketing/Broadcasts/BroadcastIndexContainer';
import BroadcastShowContainer from '../bundles/Marketing/Broadcasts/BroadcastShowContainer';
import BroadcastNewContainer from '../bundles/Marketing/Broadcasts/BroadcastNewContainer';
import BroadcastEditContainer from '../bundles/Marketing/Broadcasts/BroadcastEditContainer';
import BroadcastComposerContainer from '../bundles/Marketing/Broadcasts/Composer/BroadcastComposerContainer';
import LandingPagesIndexContainer from '../bundles/Marketing/LandingPages/LandingPagesIndexContainer';
import LandingPageBuilderContainer from '../bundles/Marketing/LandingPages/LandingPageBuilderContainer';
import BroadcastReportContainer from '../bundles/Marketing/Broadcasts/Report/BroadcastReportContainer';
import MarketingSettingsIndexContainer from '../bundles/Marketing/MarketingSettings/MarketingSettingsIndexContainer';
import SignupFormsIndexContainer from '../bundles/Marketing/SignupForms/SignupFormsIndexContainer';
import SignupFormBuilderContainer from '../bundles/Marketing/SignupForms/SignupFormBuilderContainer';
import MailkickSubscriptionIndexContainer from '../bundles/Marketing/MailkickSubscriptions/MailkickSubscriptionIndexContainer';
import BeefreeAddonIndexContainer from '../bundles/Marketing/BeefreeTemplates/BeefreeAddonIndexContainer';
import AhoyMessageShowContainer from '../bundles/Marketing/AhoyMessages/AhoyMessageShowContainer';
import AhoyMessageIndexContainer from '../bundles/Marketing/AhoyMessages/AhoyMessageIndexContainer';
import BeefreeTemplateBlueprintEditor from '../bundles/Marketing/BeefreeTemplateBlueprints/BeefreeTemplateBlueprintEditor';
import MembershipProductNewContainer from '../bundles/MembershipProducts/MembershipProductNewContainer';
import MembershipProductShowApp from '../bundles/MembershipProducts/startup/MembershipProductShowApp';
import MembershipShowApp from '../bundles/Memberships/startup/MembershipShowApp';
import MembershipCheckoutWidgetApp from '../bundles/MembershipCheckoutWidget/startup/MembershipCheckoutWidgetApp';
import MembershipSuccessApp from '../bundles/MembershipSuccess/startup/MembershipSuccessApp';
import OfferEditUIApp from '../bundles/OfferEditUI/startup/OfferEditUIApp';
import V3OfferEditApp from '../bundles/OfferEditUI/startup/V3OfferEditApp';
import OfferManagerApp from '../bundles/OfferManager/startup/OfferManagerApp';
import OfferV2PreviewApp from '../bundles/OfferV2Preview/startup/OfferV2PreviewApp';
import OnepostComposer from '../bundles/OnepostComposer/components/OnepostComposer';
import OrderPageApp from '../bundles/OrderPage/startup/OrderPageApp';
import OutreachManagerApp from '../bundles/OutreachManager/startup/OutreachManagerApp';
import PipelineEventsSlidingPaneApp from '../bundles/PipelineEventsSlidingPane/startup/PipelineEventsSlidingPaneApp';
import PostedPostsApp from '../bundles/PostedPosts/startup/PostedPostsApp';
import ProfitAndLossApp from '../bundles/ProfitAndLoss/startup/ProfitAndLossApp';
import PushNotificationsApp from '../bundles/PushNotifications/startup/PushNotificationsApp';
import ReadMore from '../bundles/ReadMore/components/ReadMore';
import RefundSettingsApp from '../bundles/RefundSettings/startup/RefundSettingsApp';
import ScheduledPostsApp from '../bundles/ScheduledPosts/startup/ScheduledPostsApp';
import SemiCircle from '../bundles/SemiCircle/components/SemiCircle';
import TicketAuditApp from '../bundles/TicketAudit/startup/TicketAuditApp';
import SettlementApp from '../bundles/Settlement/startup/SettlementApp';
import V3SettlementApp from '../bundles/V3Settlement/startup/V3SettlementApp';
import V3OfferPreviewApp from '../bundles/V3OfferPreview/startup/V3OfferPreviewApp';
import SocialManagerApp from '../bundles/SocialManager/startup/SocialManagerApp';
import TableViewApp from '../bundles/TableView/startup/TableViewApp';
import TagManagerApp from '../bundles/TagManager/startup/TagManagerApp';
import TourManagerApp from '../bundles/TourManager/startup/TourManagerApp';
import ContainerlessTableViewApp from '../bundles/TableView/startup/ContainerlessTableViewApp';
import TeamManagerApp from '../bundles/TeamManager/startup/TeamManagerApp';
import TextMessagesApp from '../bundles/TextMessages/startup/TextMessagesApp';
import VolunteersApp from '../bundles/Volunteers/startup/VolunteersApp';
import ContactsApp from '../bundles/Contacts/startup/ContactsApp';
import DuplicatesApp from '../bundles/Contacts/startup/DuplicatesApp';
import ContactDetailsApp from '../bundles/ContactsDetail/startup/ContactDetailsApp';
import CrmDashboardApp from '../bundles/CrmDashboard/startup/CrmDashboardApp';
import TicketsApp from '../bundles/TicketsPage/startup/TicketsApp';
import PledgeDetailPage from '../bundles/CrmPledgeDetail/components/PledgeDetailPage';
import ReportingDashboardApp from '../bundles/ReportingDashboard/startup/ReportingDashboardApp';
import ReportingDashboardNewApp from '../bundles/ReportingDashboard/startup/ReportingDashboardNewApp';
import ReportingSalesApp from '../bundles/ReportingDashboard/startup/ReportingSalesApp';
import ReportingSalesTicketsApp from '../bundles/ReportingDashboard/startup/ReportingSalesTicketsApp';
import ReportingSalesBySourceApp from '../bundles/ReportingDashboard/startup/ReportingSalesBySourceApp';
import ReportingSalesAddonsApp from '../bundles/ReportingDashboard/startup/ReportingSalesAddonsApp';
import ReportingSalesDonationsApp from '../bundles/ReportingDashboard/startup/ReportingSalesDonationsApp';
import ReportingMarketingPromoCodesApp from '../bundles/ReportingDashboard/startup/ReportingMarketingPromoCodesApp';
import ReportingFinancesRefundsApp from '../bundles/ReportingDashboard/startup/ReportingFinancesRefundsApp';
import RefundRequestsApp from '../bundles/RefundRequests/startup/RefundRequestsApp';
import ReportingSalesMembershipsApp from '../bundles/ReportingDashboard/startup/ReportingSalesMembershipsApp';
import ReportingSalesPacksApp from '../bundles/ReportingDashboard/startup/ReportingSalesPacksApp';
import ReportingCompareEventsApp from '../bundles/ReportingDashboard/startup/ReportingCompareEventsApp';
import ReportingEventsApp from '../bundles/ReportingDashboard/startup/ReportingEventsApp';
import ReportingEventsAttendanceApp from '../bundles/ReportingDashboard/startup/ReportingEventsAttendanceApp';
import ReportingBookingApp from '../bundles/ReportingDashboard/startup/ReportingBookingApp';
import ReportingBookingHoldsApp from '../bundles/ReportingDashboard/startup/ReportingBookingHoldsApp';
import ReportingBookingOffersApp from '../bundles/ReportingDashboard/startup/ReportingBookingOffersApp';
import ReportingBookingContactsApp from '../bundles/ReportingDashboard/startup/ReportingBookingContactsApp';
import ReportingFnbApp from '../bundles/ReportingDashboard/startup/ReportingFnbApp';
import ReportingFoodAndBeverageToastSyncApp from '../bundles/ReportingDashboard/startup/ReportingFoodAndBeverageToastSyncApp';
import ReportingSalesDiceSyncApp from '../bundles/ReportingDashboard/startup/ReportingSalesDiceSyncApp';
import ReportingFoodAndBeverageToastSalesApp from '../bundles/ReportingDashboard/startup/ReportingFoodAndBeverageToastSalesApp';
import ReportingFinancesApp from '../bundles/ReportingDashboard/startup/ReportingFinancesApp';
import ReportingFinancesDepositsApp from '../bundles/ReportingDashboard/startup/ReportingFinancesDepositsApp';
import ReportingFinancesEventPnlApp from '../bundles/ReportingDashboard/startup/ReportingFinancesEventPnlApp';
import ReportingFinancesSalesTaxApp from '../bundles/ReportingDashboard/startup/ReportingFinancesSalesTaxApp';
import ReportingFinancesPaymentsApp from '../bundles/ReportingDashboard/startup/ReportingFinancesPaymentsApp';
import ReportingFinancesGeneralLedgerApp from '../bundles/ReportingDashboard/startup/ReportingFinancesGeneralLedgerApp';
import ReportingFinancesLedgerLineItemsApp from '../bundles/ReportingDashboard/startup/ReportingFinancesLedgerLineItemsApp';
import ReportingFinancesSettlementsApp from '../bundles/ReportingDashboard/startup/ReportingFinancesSettlementsApp';
import ReportingFinancesTaxWithholdingApp from '../bundles/ReportingDashboard/startup/ReportingFinancesTaxWithholdingApp';
import ReportingFinancesChargebacksApp from '../bundles/ReportingDashboard/startup/ReportingFinancesChargebacksApp';
import ReportingFinancesLineItemsApp from '../bundles/ReportingDashboard/startup/ReportingFinancesLineItemsApp';
import ReportingFinancesPayoutsApp from '../bundles/ReportingDashboard/startup/ReportingFinancesPayoutsApp';
import ReportingFinancesW9TrackingApp from '../bundles/ReportingDashboard/startup/ReportingFinancesW9TrackingApp';
import ReportingMarketingApp from '../bundles/ReportingDashboard/startup/ReportingMarketingApp';
import ReportingMarketingEmailApp from '../bundles/ReportingDashboard/startup/ReportingMarketingEmailApp';
import ReportingMarketingSmsApp from '../bundles/ReportingDashboard/startup/ReportingMarketingSmsApp';
import ReportingMarketingWebApp from '../bundles/ReportingDashboard/startup/ReportingMarketingWebApp';
import ReportingMarketingDemographicsApp from '../bundles/ReportingDashboard/startup/ReportingMarketingDemographicsApp';
import CMCalculatorV2App from '../bundles/CMCalculatorV2/startup/CMCalculatorV2App';
import CMDashboardApp from '../bundles/CMDashboard/startup/CMDashboardApp';
import ReportingMarketingEventHealthApp from '../bundles/ReportingDashboard/startup/ReportingMarketingEventHealthApp';
import ReportingMarketingMetaAdsApp from '../bundles/ReportingDashboard/startup/ReportingMarketingMetaAdsApp';
import ReportingMarketingShowTrackerApp from '../bundles/ReportingDashboard/startup/ReportingMarketingShowTrackerApp';
import ReportingMarketingAttributionApp from '../bundles/ReportingDashboard/startup/ReportingMarketingAttributionApp';
import ReportingDonationsApp from '../bundles/ReportingDashboard/startup/ReportingDonationsApp';
import ReportingDonationsAllDonorsApp from '../bundles/ReportingDashboard/startup/ReportingDonationsAllDonorsApp';
import ReportingDonationsTopDonorsApp from '../bundles/ReportingDashboard/startup/ReportingDonationsTopDonorsApp';
import ReportingDonationsOutstandingPledgesApp from '../bundles/ReportingDashboard/startup/ReportingDonationsOutstandingPledgesApp';
import ReportingGivingByCampaignApp from '../bundles/ReportingDashboard/startup/ReportingGivingByCampaignApp';
import ReportingDonationThankYouApp from '../bundles/ReportingDashboard/startup/ReportingDonationThankYouApp';
import ReportingGivingByFundApp from '../bundles/ReportingDashboard/startup/ReportingGivingByFundApp';
import ReportingGivingDonationsApp from '../bundles/ReportingDashboard/startup/ReportingGivingDonationsApp';
import ReportingDonationsYearOverYearApp from '../bundles/ReportingDashboard/startup/ReportingDonationsYearOverYearApp';
import ReportingDonationsLybuntSybuntApp from '../bundles/ReportingDashboard/startup/ReportingDonationsLybuntSybuntApp';
import ReportingDonationsYearEndSummaryApp from '../bundles/ReportingDashboard/startup/ReportingDonationsYearEndSummaryApp';
import ReportingMembershipsApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsApp';
import ReportingMembershipsCurrentMembersApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsCurrentMembersApp';
import ReportingMembershipsPendingCancelationsApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsPendingCancelationsApp';
import ReportingMembershipsLapsedApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsLapsedApp';
import ReportingMembershipsUpcomingRenewalsApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsUpcomingRenewalsApp';
import ReportingMembershipsFailedPaymentsApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsFailedPaymentsApp';
import ReportingMembershipsRevenueApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsRevenueApp';
import ReportingMembershipsGrowthApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsGrowthApp';
import ReportingMembershipsEngagementApp from '../bundles/ReportingDashboard/startup/ReportingMembershipsEngagementApp';
import ReportingGiftCardsApp from '../bundles/ReportingDashboard/startup/ReportingGiftCardsApp';
import ReportingGiftCardsLiabilityApp from '../bundles/ReportingDashboard/startup/ReportingGiftCardsLiabilityApp';
import ReportingGiftCardsSalesApp from '../bundles/ReportingDashboard/startup/ReportingGiftCardsSalesApp';
import ReportingGiftCardsRedemptionsApp from '../bundles/ReportingDashboard/startup/ReportingGiftCardsRedemptionsApp';
import ReportingGiftCardsLedgerApp from '../bundles/ReportingDashboard/startup/ReportingGiftCardsLedgerApp';
import TicketingSystemsApp from '../bundles/TicketingSystems/startup/TicketingSystemsApp';
import TransactionsApp from '../bundles/Transactions/startup/TransactionsApp';
import ToolTip from '../bundles/ToolTip/components/ToolTip';
import UserSettingsApp from '../bundles/UserSettings/startup/UserSettingsApp';
import SettingsSectionNav from '../shared/SettingsSectionNav';
import DeleteAccountCard from '../shared/DeleteAccountCard';
import EmailAddressesCard from '../shared/EmailAddressesCard';
import ConductorTextingCard from '../shared/ConductorTextingCard';
import VenueManagerApp from '../bundles/VenueManager/startup/VenueManagerApp';
import WebOrderFormApp from '../bundles/WebOrderForm/startup/WebOrderFormApp';
import OfferV2ModalApp from '../bundles/OfferV2Modal/startup/OfferV2ModalApp'
import ArtistsSearchApp from '../bundles/ArtistsSearch/startup/ArtistsSearchApp';
import GlobalArtistsSearchApp from '../bundles/GlobalArtistsSearch/startup/GlobalArtistsSearchApp';
import ArtistEventLocalShowApp from '../bundles/ArtistEventLocalShow/startup/ArtistEventLocalShowApp';
import ArtistPipelinesApp from '../bundles/ArtistPipelines/startup/ArtistPipelinesApp';
import SimilarArtistsApp from '../bundles/SimilarArtists/startup/SimilarArtistsApp';
import ShowActivitySettingsApp from '../bundles/ShowActivitySettings/startup/ShowActivitySettingsApp';
import StripeConnectApp from '../bundles/StripeConnect/startup/StripeConnectApp';
import UniversalPromoCodeManagerApp from '../bundles/UniversalPromoCodeManager/startup/UniversalPromoCodeManagerApp';
import TrackingLinksApp from '../bundles/TrackingLinks/startup/TrackingLinksApp';
import ArtistDetailsApp from '../bundles/ArtistDetails/startup/ArtistDetailsApp';
import PaymentDisputeManagerApp from '../bundles/PaymentDisputeManager/startup/PaymentDisputeManagerApp';
import PaymentReviewManagerApp from '../bundles/PaymentReviewManager/startup/PaymentReviewManagerApp';
import RiskDeskApp from '../bundles/RiskDesk/startup/RiskDeskApp';
import NavigationTypeEditorApp from '../bundles/NavigationTypeEditor/startup/NavigationTypeEditorApp';
import AdminDashboardApp from '../bundles/AdminDashboard/startup/AdminDashboardApp';
import DomainRulesApp from '../bundles/DomainRules/startup/DomainRulesApp';
import TicketHistoryApp from '../bundles/TicketHistory/startup/TicketHistoryApp';
import FinanceOverviewApp from '../bundles/FinanceOverview/startup/FinanceOverviewApp';
import FinanceTabsApp from '../bundles/FinanceTabs/startup/FinanceTabsApp';
import PayoutManagerApp from '../bundles/PayoutManager/startup/PayoutManagerApp';
import FinanceSettingsManagerApp from '../bundles/FinanceSettingsManager/startup/FinanceSettingsManagerApp';
import MyArtistsApp from '../bundles/MyArtists/startup/MyArtistsApp';
import ArtistsBrowseApp from '../bundles/ArtistsBrowse/startup/ArtistsBrowseApp';
import AdminCSVImporterContainer from '../bundles/CSVImporter/AdminCSVImporterContainer';
import RentalInvoiceEditContainer from '../bundles/RentalInvoice/RentalInvoiceEditContainer';
import RentalInvoicePreviewContainer from '../bundles/RentalInvoice/RentalInvoicePreviewContainer';
import OrganizationsApp from '../bundles/Organizations/startup/OrganizationsApp';
import OrganizationDetailsApp from '../bundles/OrganizationsDetail/startup/OrganizationDetailsApp';
import CrmSettingsApp from '../bundles/CrmSettings/startup/CrmSettingsApp';
import CrmLabelsApp from '../bundles/CrmLabels/startup/CrmLabelsApp';
import CrmConstituentIdsApp from '../bundles/CrmConstituentIds/startup/CrmConstituentIdsApp';
import CrmTagsApp from '../bundles/CrmTags/startup/CrmTagsApp';
import CrmDonorFeaturesApp from '../bundles/CrmDonorFeatures/startup/CrmDonorFeaturesApp';
import CrmContactTypesApp from '../bundles/CrmContactTypes/startup/CrmContactTypesApp';
import CrmObjectsApp from '../bundles/CrmObjects/startup/CrmObjectsApp';
import CrmAttributesApp from '../bundles/CrmAttributes/startup/CrmAttributesApp';
import TasksApp from '../bundles/Tasks/startup/TasksApp';
import TasksDetailApp from '../bundles/TasksDetail/startup/TasksDetailApp';
import DealsApp from '../bundles/Deals/startup/DealsApp';
import GrantsApp from '../bundles/Grants/startup/GrantsApp';
import GrantDetailApp from '../bundles/GrantDetail/startup/GrantDetailApp';
import DealsDetailApp from '../bundles/DealsDetail/startup/DealsDetailApp';
import SettingsApp from '../bundles/Settings/SettingsApp';
import OnboardingApp from '../bundles/Onboarding/OnboardingApp';
import SettingsAccountDetailsApp from '../bundles/SettingsAccountDetails/SettingsAccountDetailsApp';
import SettingsTeamDetailsApp from '../bundles/SettingsTeamDetails/SettingsTeamDetailsApp';
import SettingsTagsDetailsApp from '../bundles/SettingsTagsDetails/SettingsTagsDetailsApp';
import SettingsVenueDetailsApp from '../bundles/SettingsVenueDetails/SettingsVenueDetailsApp';
import SettingsIntegrationDetailsApp from '../bundles/SettingsIntegrationDetails/SettingsIntegrationDetailsApp';
import SettingsMembershipDetailsApp from '../bundles/SettingsMembershipDetails/SettingsMembershipDetailsApp';
import SettingsTicketingDetailsApp from '../bundles/SettingsTicketingDetails/SettingsTicketingDetailsApp';
import SettingsBillingAndPaymentDetailsApp from '../bundles/SettingsBillingAndPaymentDetails/SettingsBillingAndPaymentDetailsApp';
import SettingsEventsDetailsApp from '../bundles/SettingsEventsDetails/SettingsEventsDetailsApp';
import SettingsHoldsDetailsApp from '../bundles/SettingsHoldsDetails/SettingsHoldsDetailsApp';
import SettingsSeriesDetailsApp from '../bundles/SettingsSeriesDetails/SettingsSeriesDetailsApp';
import SettingsGiftCardsApp from '../bundles/SettingsGiftCards/SettingsGiftCardsApp';
import GiftCardProductsApp from '../bundles/GiftCardProducts/GiftCardProductsApp';
import GiftCardProductEditorApp from '../bundles/GiftCardProducts/GiftCardProductEditorApp';
import GiftCardsApp from '../bundles/GiftCards/GiftCardsApp';
import GiftCardDetailApp from '../bundles/GiftCards/GiftCardDetailApp';
import ComplimentaryGiftCardApp from '../bundles/GiftCards/ComplimentaryGiftCardApp';
import GiftCardRedeemApp from '../bundles/GiftCards/GiftCardRedeemApp';
import GiftCardPurchase from '../bundles/GiftCardPurchase/components/GiftCardPurchase';
import GiftCardBalanceCheck from '../bundles/GiftCardBalanceCheck/GiftCardBalanceCheck';
import SettingsOffersDetailsApp from '../bundles/SettingsOffersDetails/SettingsOffersDetailsApp';
import SettingsCurrencyDetailsApp from '../bundles/SettingsCurrencyDetails/SettingsCurrencyDetailsApp';
import SettingsAssetsDetailsApp from '../bundles/SettingsAssetsDetails/SettingsAssetsDetailsApp';
import SettingsProfitAndLossApp from '../bundles/SettingsProfitAndLoss/SettingsProfitAndLossApp';
import MetaAdAccountSelectorApp from '../bundles/MetaAdAccountSelector/MetaAdAccountSelectorApp';
import MetaSocialAdsApp from '../bundles/MetaSocialAds/MetaSocialAdsApp';
import UserManualApp from '../bundles/UserManual/startup/UserManualApp';
import ReportingBookingArtistSuggestionsApp from '../bundles/ReportingDashboard/startup/ReportingBookingArtistSuggestionsApp';
import ReportingBookingCompetitiveVenuesApp from '../bundles/ReportingDashboard/startup/ReportingBookingCompetitiveVenuesApp';
import TableAssignmentsApp from '../bundles/TableAssignments/startup/TableAssignmentsApp';
import SeriesShowApp from '../bundles/SeriesShow/SeriesShowApp';
import SeriesEditApp from '../bundles/SeriesEdit/SeriesEditApp';
import SeriesIndexApp from '../bundles/SeriesIndex/SeriesIndexApp';
import CollectionsIndexApp from '../bundles/CollectionsIndex/CollectionsIndexApp';
import InstructorsApp from '../bundles/Instructors/InstructorsApp';
import TodayApp from '../bundles/Today/TodayApp';
import TicketFeeCalculatorApp from '../bundles/TicketFeeCalculator/TicketFeeCalculatorApp';
import InstructorFormApp from '../bundles/Instructors/InstructorFormApp';
import InstructorShowApp from '../bundles/Instructors/InstructorShowApp';
import ClassTemplatesApp from '../bundles/ClassTemplates/ClassTemplatesApp';
import ClassTemplateShowApp from '../bundles/ClassTemplates/ClassTemplateShowApp';
import ClassTemplateWizardApp from '../bundles/ClassTemplateWizard/ClassTemplateWizardApp';
import ClassesIndexApp from '../bundles/ClassInstances/ClassesIndexApp';
import ClassInstanceShowApp from '../bundles/ClassInstances/ClassInstanceShowApp';
import ClassRegistrationShowApp from '../bundles/ClassInstances/ClassRegistrationShowApp';
import ClassesSectionNavigationApp from '../bundles/ClassesShared/ClassesSectionNavigationApp';
import AttributionProfileActivityApp from '../bundles/AttributionProfileActivity/AttributionProfileActivityApp';
import StaffingDepartmentsApp from '../bundles/Staffing/StaffingDepartmentsApp';
import StaffingPeopleApp from '../bundles/Staffing/StaffingPeopleApp';
import StaffingPersonApp from '../bundles/Staffing/StaffingPersonApp';
import StaffingScheduleApp from '../bundles/Staffing/StaffingScheduleApp';
import StaffingPermissionsApp from '../bundles/Staffing/StaffingPermissionsApp';
import StaffingRequestsApp from '../bundles/Staffing/StaffingRequestsApp';
import StaffingAvailabilityApp from '../bundles/Staffing/StaffingAvailabilityApp';
import StaffingTimesheetsApp from '../bundles/Staffing/StaffingTimesheetsApp';
import StaffingSettingsApp from '../bundles/Staffing/StaffingSettingsApp';
import StaffingTemplatesApp from '../bundles/Staffing/StaffingTemplatesApp';
import ClassScheduleWizardApp from '../bundles/ClassScheduleWizard/ClassScheduleWizardApp';
import SeriesPassCheckout from '../bundles/SeriesPassCheckout/components/SeriesPassCheckout';
import ClassRegistrationCheckout from '../bundles/ClassRegistrationCheckout/components/ClassRegistrationCheckout';
import SeriesEntryPicker from '../bundles/SeriesEntryPicker/components/SeriesEntryPicker';
import SimpleOfferEditApp from '../bundles/OfferEditUI/startup/SimpleOfferEditApp';
import SetupChecklistApp from '../bundles/SetupChecklist/startup/SetupChecklistApp';
import ReportingClassesApp from '../bundles/ReportingDashboard/startup/ReportingClassesApp';
import ReportingClassesSalesApp from '../bundles/ReportingDashboard/startup/ReportingClassesSalesApp';
import ReportingClassesRegistrationsApp from '../bundles/ReportingDashboard/startup/ReportingClassesRegistrationsApp';
import ReportingStaffingApp from '../bundles/ReportingDashboard/startup/ReportingStaffingApp';
import ReportingStaffingReportApp from '../bundles/ReportingDashboard/startup/ReportingStaffingReportApp';

ReactOnRails.register({
  AddConfirmToCalendar,
  AddOutreachApp,
  ArtistRepresentationApp,
  ArtistsBrowseApp,
  OfferV2ModalApp,
  ActivityFeedApp,
  AgentsTableApp,
  AppMenuApp,
  MobileMenuApp,
  BulkRefundApp,
  CalendarViewApp,
  CalendarViewV2App,
  CapacityBarChart,
  CheckoutAccordionApp,
  EditArtistSpotifyApp,
  EditArtistSocialApp,
  AgentDetailsApp,
  AgentRosterApp,
  ArtistContactsApp,
  VenueConductorApp,
  VenueConductorModalApp,
  ConfirmAttendeesApp,
  ConfirmationMemoApp,
  ConfirmDashboardApp,
  ConfirmShowApp,
  ConfirmTicketingApp,
  DataTable,
  DataTableWithSidebarViewApp,
  EditTourApp,
  EmailNotificationSettingsApp,
  EventPageApp,
  EventQrCodeApp,
  TrackableLinkQrCodeApp,
  EventsAssetCenterApp,
  FanDashboardApp,
  FanUpcomingEventsApp,
  FollowUpManagerApp,
  GivingCampaignDashboardApp,
  GivingCampaignDetailApp,
  GivingCampaignFormApp,
  GivingCampaignTypeSelectorApp,
  PublicGivingCampaignApp,
  GlobalAssetCenterApp,
  InboundSubmissionsApp,
  LinkOfferModalApp,
  MembershipProductNewContainer,
  MembershipProductShowApp,
  MembershipShowApp,
  MembershipCheckoutWidgetApp,
  MembershipSuccessApp,
  OfferEditUIApp,
  V3OfferEditApp,
  MapWithMarker,
  MapWithMarkerClusters,
  MarketingInsightsApp,
  MetaAdsDetailsApp,
  ActionContainer,
  CampaignsContainer,
  CampaignContainer,
  CustomCampaignShowContainer,
  SegmentsContainer,
  SegmentContainer,
  SegmentNewContainer,
  SegmentEditContainer,
  SetlistPageHeaderApp,
  BroadcastIndexContainer,
  BroadcastShowContainer,
  BroadcastNewContainer,
  BroadcastEditContainer,
  BroadcastComposerContainer,
  LandingPagesIndexContainer,
  LandingPageBuilderContainer,
  BroadcastReportContainer,
  MarketingSettingsIndexContainer,
  SignupFormsIndexContainer,
  SignupFormBuilderContainer,
  MailkickSubscriptionIndexContainer,
  BeefreeAddonIndexContainer,
  BeefreeTemplateBlueprintEditor,
  AhoyMessageShowContainer,
  AhoyMessageIndexContainer,
  OfferManagerApp,
  OfferV2PreviewApp,
  OnepostComposer,
  OrderPageApp,
  OutreachManagerApp,
  PipelineEventsSlidingPaneApp,
  PostedPostsApp,
  ProfitAndLossApp,
  PushNotificationsApp,
  ReadMore,
  RefundSettingsApp,
  ScheduledPostsApp,
  SemiCircle,
  TicketAuditApp,
  SettlementApp,
  V3SettlementApp,
  V3OfferPreviewApp,
  SocialManagerApp,
  TableAssignmentsApp,
  TableViewApp,
  TagManagerApp,
  TourManagerApp,
  ContainerlessTableViewApp,
  TeamManagerApp,
  TextMessagesApp,
  VolunteersApp,
  ContactsApp,
  DuplicatesApp,
  ContactDetailsApp,
  CrmDashboardApp,
  TicketsApp,
  PledgeDetailPage,
  ReportingDashboardApp,
  ReportingDashboardNewApp,
  ReportingSalesApp,
  ReportingSalesTicketsApp,
  ReportingSalesBySourceApp,
  ReportingSalesAddonsApp,
  ReportingSalesDonationsApp,
  ReportingMarketingPromoCodesApp,
  ReportingFinancesRefundsApp,
  RefundRequestsApp,
  ReportingSalesMembershipsApp,
  ReportingSalesPacksApp,
  ReportingCompareEventsApp,
  ReportingEventsApp,
  ReportingEventsAttendanceApp,
  ReportingBookingApp,
  ReportingBookingHoldsApp,
  ReportingBookingOffersApp,
  ReportingBookingContactsApp,
  ReportingFnbApp,
  ReportingFoodAndBeverageToastSyncApp,
  ReportingSalesDiceSyncApp,
  ReportingFoodAndBeverageToastSalesApp,
  ReportingFinancesApp,
  ReportingFinancesDepositsApp,
  ReportingFinancesEventPnlApp,
  ReportingFinancesSalesTaxApp,
  ReportingFinancesPaymentsApp,
  ReportingFinancesGeneralLedgerApp,
  ReportingFinancesLedgerLineItemsApp,
  ReportingFinancesSettlementsApp,
  ReportingFinancesTaxWithholdingApp,
  ReportingFinancesChargebacksApp,
  ReportingFinancesLineItemsApp,
  ReportingFinancesPayoutsApp,
  ReportingFinancesW9TrackingApp,
  ReportingMarketingApp,
  ReportingMarketingEmailApp,
  ReportingMarketingSmsApp,
  ReportingMarketingWebApp,
  ReportingMarketingDemographicsApp,
  CMCalculatorV2App,
  CMDashboardApp,
  ReportingMarketingEventHealthApp,
  ReportingMarketingMetaAdsApp,
  ReportingMarketingShowTrackerApp,
  ReportingMarketingAttributionApp,
  ReportingDonationsApp,
  ReportingDonationsAllDonorsApp,
  ReportingDonationsTopDonorsApp,
  ReportingDonationsOutstandingPledgesApp,
  ReportingGivingByCampaignApp,
  ReportingGivingByFundApp,
  ReportingDonationThankYouApp,
  ReportingGivingDonationsApp,
  ReportingDonationsYearOverYearApp,
  ReportingDonationsLybuntSybuntApp,
  ReportingDonationsYearEndSummaryApp,
  ReportingMembershipsApp,
  ReportingMembershipsCurrentMembersApp,
  ReportingMembershipsPendingCancelationsApp,
  ReportingMembershipsLapsedApp,
  ReportingMembershipsUpcomingRenewalsApp,
  ReportingMembershipsFailedPaymentsApp,
  ReportingMembershipsRevenueApp,
  ReportingMembershipsGrowthApp,
  ReportingMembershipsEngagementApp,
  ReportingGiftCardsApp,
  ReportingGiftCardsLiabilityApp,
  ReportingGiftCardsSalesApp,
  ReportingGiftCardsRedemptionsApp,
  ReportingGiftCardsLedgerApp,
  TicketingSystemsApp,
  TransactionsApp,
  ToolTip,
  UserSettingsApp,
  SettingsSectionNav,
  DeleteAccountCard,
  EmailAddressesCard,
  ConductorTextingCard,
  VenueManagerApp,
  WebOrderFormApp,
  ArtistsSearchApp,
  GlobalArtistsSearchApp,
  ArtistEventLocalShowApp,
  ArtistPipelinesApp,
  SimilarArtistsApp,
  ShowActivitySettingsApp,
  StripeConnectApp,
  UniversalPromoCodeManagerApp,
  TrackingLinksApp,
  ArtistDetailsApp,
  PaymentDisputeManagerApp,
  PaymentReviewManagerApp,
  RiskDeskApp,
  NavigationTypeEditorApp,
  AdminDashboardApp,
  DomainRulesApp,
  TicketHistoryApp,
  FinanceOverviewApp,
  FinanceTabsApp,
  PayoutManagerApp,
  FinanceSettingsManagerApp,
  MyArtistsApp,
  AdminCSVImporterContainer,
  RentalInvoiceEditContainer,
  RentalInvoicePreviewContainer,
  OrganizationsApp,
  OrganizationDetailsApp,
  CrmSettingsApp,
  CrmLabelsApp,
  CrmConstituentIdsApp,
  CrmTagsApp,
  CrmDonorFeaturesApp,
  CrmContactTypesApp,
  CrmObjectsApp,
  CrmAttributesApp,
  TasksApp,
  TasksDetailApp,
  DealsApp,
  GrantsApp,
  GrantDetailApp,
  DealsDetailApp,
  SettingsApp,
  OnboardingApp,
  SettingsAccountDetailsApp,
  SettingsTeamDetailsApp,
  SettingsTagsDetailsApp,
  SettingsVenueDetailsApp,
  SettingsIntegrationDetailsApp,
  SettingsMembershipDetailsApp,
  SettingsTicketingDetailsApp,
  SettingsBillingAndPaymentDetailsApp,
  SettingsEventsDetailsApp,
  SettingsHoldsDetailsApp,
  SettingsSeriesDetailsApp,
  SettingsGiftCardsApp,
  GiftCardProductsApp,
  GiftCardProductEditorApp,
  GiftCardsApp,
  GiftCardDetailApp,
  ComplimentaryGiftCardApp,
  GiftCardRedeemApp,
  GiftCardPurchase,
  GiftCardBalanceCheck,
  SettingsOffersDetailsApp,
  SettingsCurrencyDetailsApp,
  SettingsAssetsDetailsApp,
  SettingsProfitAndLossApp,
  MetaAdAccountSelectorApp,
  MetaSocialAdsApp,
  UserManualApp,
  ReportingBookingArtistSuggestionsApp,
  ReportingBookingCompetitiveVenuesApp,
  SeriesShowApp,
  SeriesEditApp,
  SeriesIndexApp,
  CollectionsIndexApp,
  InstructorsApp,
  TodayApp,
  TicketFeeCalculatorApp,
  InstructorFormApp,
  InstructorShowApp,
  ClassTemplatesApp,
  ClassTemplateShowApp,
  ClassTemplateWizardApp,
  ClassesIndexApp,
  ClassInstanceShowApp,
  ClassRegistrationShowApp,
  ClassesSectionNavigationApp,
  AttributionProfileActivityApp,
  StaffingDepartmentsApp,
  StaffingPeopleApp,
  StaffingPersonApp,
  StaffingScheduleApp,
  StaffingPermissionsApp,
  StaffingRequestsApp,
  StaffingAvailabilityApp,
  StaffingTimesheetsApp,
  StaffingSettingsApp,
  StaffingTemplatesApp,
  ClassScheduleWizardApp,
  SeriesPassCheckout,
  ClassRegistrationCheckout,
  SeriesEntryPicker,
  SimpleOfferEditApp,
  SetupChecklistApp,
  ReportingClassesApp,
  ReportingClassesSalesApp,
  ReportingClassesRegistrationsApp,
  ReportingStaffingApp,
  ReportingStaffingReportApp,
});
